import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Table } from "reactstrap";
import "../Banner/banner.css";
import api from "../../Axios";
import NotificationAlert from "react-notification-alert";
import { Link } from "react-router-dom";
const ViewMembership = () => {
  const notiRef = useRef();

  const [membershiplist, setMembershipList] = useState();
  const [render, setRender] = useState(false);

  function deletee(i) {
    // console.log(i);
    api
      .post("/admin/membership/membershipStatusUpdate", {
        id: i.id,
        status: i.status === "active" ? "inactive" : "active",
      })
      .then(() => {
        api.get("/admin/membership/viewAllMembership").then((res) => {
          setMembershipList(res.data.data);
        });
      });
  }
  useEffect(() => {
    api.get("/admin/membership/viewAllMembership").then((res) => {
      // console.log(res.data.data);
      setMembershipList(res.data.data);
    });
  }, [render]);

  return (
    <div>
      <div className="content">
        <div className="notification-popup">
          <NotificationAlert ref={notiRef} />
        </div>
        <Row>
          <Col xs={12} md={12}>
            <Row>
              <div className="container-fluid p-3 mt-5">
                <section className="box">
                  <Table
                    style={{
                      borderCollapse: "separate",
                      borderSpacing: "0 12px",
                    }}
                  >
                    <thead
                      style={{
                        background: "black",
                        color: "white",
                        marginLeft: "10px",
                      }}
                    >
                      <tr>
                        <th style={{ textAlign: "center" }}>S No</th>
                        <th style={{ textAlign: "center" }}>Plan Name</th>
                        <th style={{ textAlign: "center" }}>Period</th>
                        <th style={{ textAlign: "center" }}>Duration</th>
                        <th style={{ textAlign: "center" }}>
                          Profile Highlighter
                        </th>
                        <th style={{ textAlign: "center" }}>
                          Regular Prime Chat
                        </th>
                        <th style={{ textAlign: "center" }}>
                          View Contact Nos
                        </th>
                        <th style={{ textAlign: "center" }}>View Horoscope</th>
                        <th style={{ textAlign: "center" }}>Send Interest</th>
                        <th style={{ textAlign: "center" }}>chat</th>
                        <th style={{ textAlign: "center" }}>Broker Service</th>
                        <th style={{ textAlign: "center" }}>Regular Price</th>
                        <th style={{ textAlign: "center" }}>Offer Price</th>

                        <th style={{ textAlign: "center" }}>Status</th>
                        <th style={{ textAlign: "center" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(membershiplist) &&
                      membershiplist.length > 0 ? (
                        membershiplist.map((membership, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                              }}
                            >
                              {" "}
                              {index + 1}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                                textTransform: "capitalize",
                              }}
                            >
                              {membership.name}
                            </td>
                            {/* <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                                textTransform: "capitalize",
                              }}
                            >
                              {membership.name}
                            </td> */}
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                                textTransform: "capitalize",
                              }}
                            >
                              {membership.period}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                              }}
                            >
                              {membership.duration}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                                textTransform: "capitalize",
                              }}
                            >
                              {membership.profileHighlighter}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                              }}
                            >
                              {membership.regularPrimeChat}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                              }}
                            >
                              {membership.viewContactNos}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                              }}
                            >
                              {membership.viewHoroscope}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                              }}
                            >
                              {membership.sendInterest}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                              }}
                            >
                              {membership.chat}
                            </td>{" "}
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                              }}
                            >
                              {membership.brokerService}
                            </td>{" "}
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                              }}
                            >
                              {membership.regularPrice}
                            </td>{" "}
                            <td
                              style={{
                                textAlign: "center",
                                color: "#000",
                                fontWeight: "500",
                              }}
                            >
                              {membership.offerPrice}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <span
                                href="#"
                                className="btn"
                                onClick={() => deletee(membership)}
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "500",
                                  background:
                                    membership.status == "active"
                                      ? "green"
                                      : "#00008B",
                                  color: "white",
                                  padding: "10px",
                                  textTransform: "capitalize",
                                }}
                              >
                                {membership.status}
                              </span>
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <Link
                                to={`/editmembership/${membership.selectPlan}/${membership.name}/${membership.id}`}
                              >
                                <span
                                  className="badge"
                                  style={{
                                    cursor: "pointer",
                                    background: "red",
                                    color: "#fff",
                                    padding: "10px",
                                    // marginLeft:"20px"
                                  }}
                                >
                                  <span>Edit</span>
                                </span>
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <div style={{ alignContent: "center", textAlign: "center", padding: "20px" }}>
                          <p>Plan Not Found</p>
                        </div>
                      )}
                    </tbody>
                  </Table>
                </section>
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ViewMembership;
